type GetGhostStyleArgs = {
  width: number;
  height: number;
  x: number;
  y: number;
  translateX: number;
  translateY: number;
};

export const getGhostStyle = ({
  width,
  height,
  x,
  y,
  translateX,
  translateY,
}: GetGhostStyleArgs): React.CSSProperties => ({
  boxSizing: 'border-box',
  width: `${width}px`,
  height: `${height}px`,
  position: 'fixed',
  top: `${y}px`,
  left: `${x}px`,
  zIndex: 10000,
  margin: 0,
  transform: `translate3d(${translateX}px, ${translateY}px, 0)`,
  pointerEvents: 'none',
});
